import { Component, OnDestroy, OnInit } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { of, Subscription } from "rxjs";
import { map, switchMap, take, tap } from "rxjs/operators";
import { filterNullOrUndefined } from "src/app/@operators/filter-null-or-undefined";
import { CityDto, ContractDto, InsurerDto, RefLanguageDto, SiteDto } from "src/app/api/models";
import { ViewLocator } from "src/app/kiosk/kiosk.view-locator";
import { AppState, getState } from "src/app/state/app.state";
import { environment } from "src/environments/environment";
import * as ArcHospiActions from "../../archospi/state/archospi.actions";
import { resetCity } from "../../city/state/city.actions";
import { getCityListCurrentProvince } from "../../city/state/city.selectors";
import { checkExistingPrehospi } from "../../hospi/state/hospi.actions";
import { resetProvince, } from "../../province/state/province.actions";
import { setTitle } from "../../title/state/title.actions";
import { setSelectedProvince, setSelectedSite, setConfirmedSite, resetCurrentProvince, resetCurrentCity } from "../../transaction-info/state/transaction-info.actions";
import { resetSite } from "../state/site.actions";

@Component({
    selector: "app-confirm-site",
    templateUrl: "./confirm-site.component.html",
    styleUrls: ["./confirm-site.component.scss"],
    standalone: false
})
export class ConfirmSiteComponent implements OnInit, OnDestroy {
	public site: SiteDto;
	public city: CityDto;
	public contract: ContractDto;
	public insurer: InsurerDto;
	public language: RefLanguageDto;
	public onlyOneCity = false;
	public onlyOneHospital = false;
	public text: string;
	private subs: Subscription[] = [];
	public properyNameToDisplay = "hospitalName";
	public properyAddressToDisplay = "adressText";

	constructor(private store: Store<AppState>, private vl: ViewLocator) {
		this.subs.push(
			getState(this.store)
			.pipe(
				tap(state=>{
					this.site = state.transactionInfo.selectedSite;
					this.city = state.transactionInfo.selectedCity;
					this.contract = state.transactionInfo.selectedContract;
					this.insurer = state.transactionInfo.selectedInsurer;
					this.language = state.transactionInfo.selectedLanguage;

					this.onlyOneHospital = (state.site.siteList?.length ?? -1) == 1; //May be undefined, for exemple in kiosk mode, the siteList is never filled
					this.text = "text" + state.transactionInfo.selectedLanguage.languageCode.toUpperCase();
					this.properyNameToDisplay = "hospitalName" + state.transactionInfo.selectedLanguage.languageCode.toUpperCase();
					this.properyAddressToDisplay = "addressText" + state.transactionInfo.selectedLanguage.languageCode.toUpperCase();
	
				}),
				switchMap( state => {
					return this.store.pipe(select(getCityListCurrentProvince)).pipe(filterNullOrUndefined(),
					tap((s) => (this.onlyOneCity = s.length == 1)),
					map( _ => state)
					);			
				})
			).subscribe()
		);
	}

	ngOnInit(): void {
		this.store.dispatch(
			setTitle({
				data: "TITLE_CONFIRM_SITE",
				data2: "TITLE_CONFIRM_SITE_YES",
				data3: "TITLE_CONFIRM_SITE_NO",
			})
		);
	}

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}

	onClickRetour() {
		if (environment.kioskMode) {
			this.store.dispatch(resetCity());
			this.store.dispatch(resetCurrentCity());
			this.store.dispatch(resetProvince());
			this.store.dispatch(resetCurrentProvince());
		}
		else {
			if (this.onlyOneCity) {
				this.store.dispatch(resetCity());
				this.store.dispatch(resetCurrentCity());
				this.store.dispatch(setSelectedProvince(undefined));
			}
			if (this.onlyOneHospital) {
				this.store.dispatch(resetCity());
				this.store.dispatch(resetCurrentCity());
			}
		}

		this.store.dispatch(resetSite());
		this.store.dispatch(setSelectedSite({ data: undefined }));
	}

	onClickOk() {
		this.store.dispatch(
			ArcHospiActions.hospitalSelected({
				siteId: this.site.siteId,
				hospitalNo: this.site.hospitalNo,
			})
		);
		this.store.dispatch(checkExistingPrehospi({ siteId: this.site.siteId, insurerId: this.contract.insurerId, contractId: this.contract.contractId }));
		this.store.dispatch(setConfirmedSite({ data: true }));
	}
}
